import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { StartupFailureHeroSection } from "@/components/insights/startup-failure/StartupFailureHeroSection";
import { StartupFailureTakeaway } from "@/components/insights/startup-failure/StartupFailureTakeaway";
import { StartupFailureFounderQuote } from "@/components/insights/startup-failure/StartupFailureFounderQuote";
import { StartupFailureReasons } from "@/components/insights/startup-failure/StartupFailureReasons";
import { StartupFailureDelegationGuide } from "@/components/insights/startup-failure/StartupFailureDelegationGuide";
import { StartupFailureWarningSign } from "@/components/insights/startup-failure/StartupFailureWarningSign";
import { InsightSEO } from "@/hooks/useInsightSEO";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const StartupFailureDelegation = () => {
  return (
    <>
      <InsightSEO 
        slug="startup-failure-delegation" 
        additionalKeywords={["startup failure", "founder delegation", "CEO burnout", "startup management", "founder syndrome", "scaling startups", "leadership delegation"]}
      />
      <InsightEngagementTracker slug="startup-failure-delegation" title="Why Startups Fail: Founder Delegation" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="Business IT" 
          currentPage="Why Startups Fail" 
        />
        <StartupFailureHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <StartupFailureTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <StartupFailureFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <StartupFailureReasons />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <StartupFailureDelegationGuide />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <StartupFailureWarningSign />
        </AnimatedSection>
        
        {/* Benchmark Tables */}
        <AnimatedSection delay={0}>
          <InsightBenchmarks insightSlug="startup-failure-delegation" />
        </AnimatedSection>
        
        {/* FAQ Section */}
        <AnimatedSection delay={0}>
          <InsightFAQSection insightSlug="startup-failure-delegation" />
        </AnimatedSection>
        
        {/* Related Tools Section */}
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="startup-failure-delegation" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default StartupFailureDelegation;
